import { useDispatch, useSelector } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { cartActions } from "../../store/cart-slice";

import addDotsToPrice from "../price-format";
import baseUrl from "../../url/baseUrl";

const CartRow = (props) => {
  let {
    productId,
    img,
    name,
    sizeInfo,
    price,
    quantity,
    totalPriceOfProduct,
    _id,
  } = props.item;

  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.loginUser.isLogin);

  // Hàm tăng giảm số lượng
  function increaseAndDecreaseQuantity() {
    const cartProductIndex = JSON.parse(
      localStorage.getItem("unLogCart")
    ).findIndex((cp) => {
      return cp.productId === productId && cp.sizeInfo === sizeInfo;
    });
    // sao chép các sản phẩm trong giỏ hàng sang array mới
    const updatedCartItems = [...JSON.parse(localStorage.getItem("unLogCart"))];
    // cập nhật số lượng sản phẩm thành số lượng mới
    updatedCartItems[cartProductIndex].quantity = quantity;
    // cập nhật tổng giá trị mới của sản phẩm
    updatedCartItems[cartProductIndex].totalPriceOfProduct =
      totalPriceOfProduct;
    // luu đối tượng đã update mới vao localstorage
    localStorage.setItem("unLogCart", JSON.stringify(updatedCartItems));
    //update for state redux
    dispatch(cartActions.updateCartItems(updatedCartItems));
    // update for totalPrice
    const priceArr = updatedCartItems.map((prod) => +prod.totalPriceOfProduct);
    dispatch(cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0)));
  }

  // UPDATE_CART actions.
  // increase
  const incrementHandler = async () => {
    quantity++;
    totalPriceOfProduct = quantity * price;
    // Neu nguoi dung dang nhap
    if (isLogin) {
      try {
        const response = await fetch(baseUrl + "/increment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify({
            productId,
            quantity,
            sizeInfo,
            totalPriceOfProduct,
          }),
        });

        if (response.status === 404) {
          throw new Error("Cannot increase quantity.");
        }

        if (response.status !== 200) {
          throw new Error("Something went wrong with server.");
        }
        const data = await response.json();
        //update for items
        dispatch(cartActions.updateCartItems(data));
        // update for totalPrice
        const priceArr = data.map((prod) => +prod.totalPriceOfProduct);
        dispatch(
          cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
        );
      } catch (err) {
        console.log(err);
      }
      // neu nguoi dung khong dang nhap
    } else {
      increaseAndDecreaseQuantity();
    }
  };
  // decrease
  const decrementHandler = async () => {
    if (quantity === 1) {
      return deleteHandler();
    }

    quantity--;
    totalPriceOfProduct = quantity * price;

    if (isLogin) {
      try {
        const response = await fetch(baseUrl + "/decrement", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify({
            productId,
            quantity,
            sizeInfo,
            totalPriceOfProduct,
          }),
        });

        if (response.status === 404) {
          throw new Error("Cannot decrease quantity.");
        }

        if (response.status !== 200) {
          throw new Error("Something went wrong with server.");
        }
        const data = await response.json();
        //update for items
        dispatch(cartActions.updateCartItems(data));
        // update for totalPrice
        const priceArr = data.map((prod) => +prod.totalPriceOfProduct);
        dispatch(
          cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
        );
      } catch (err) {
        console.log(err);
      }
    } else {
      increaseAndDecreaseQuantity();
    }
  };

  // DELETE.
  const deleteHandler = async () => {
    if (isLogin) {
      try {
        const response = await fetch(baseUrl + "/remove-item", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify({
            _id,
            sizeInfo,
          }),
        });

        if (response.status === 404) {
          throw new Error("Cannot Delete product!");
        }

        if (response.status !== 200) {
          throw new Error("Something went wrong with server.");
        }

        const data = await response.json();
        //update for items
        dispatch(cartActions.updateCartItems(data));
        // update for totalPrice
        const priceArr = data.map((prod) => +prod.totalPriceOfProduct);
        dispatch(
          cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
        );
      } catch (err) {
        console.log(err);
      }
    } else {
      // lọc ra các sản phẩm không phải là sản phẩm muốn xóa
      const updatedCartItems = JSON.parse(
        localStorage.getItem("unLogCart")
      ).filter((cp) => {
        return cp._id !== _id;
      });

      // lưu các sản phẩm này vào localstorage
      localStorage.setItem("unLogCart", JSON.stringify(updatedCartItems));
      //update for state redux
      dispatch(cartActions.updateCartItems(updatedCartItems));
      // update for totalPrice
      const priceArr = updatedCartItems.map(
        (prod) => +prod.totalPriceOfProduct
      );
      dispatch(
        cartActions.updatedCartPrice(priceArr.reduce((a, b) => a + b, 0))
      );
    }
  };

  return (
    <tr className="align-middle">
      <td>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => props.onSelect(_id)}
        />
      </td>
      <td>
        <img src={img} alt={name} className="img-fluid" />
      </td>
      <td className="td_name">{name}</td>
      <td>{sizeInfo}</td>
      <td className="td_price">{addDotsToPrice(price)}</td>
      <td>
        <button onClick={decrementHandler}>&#9664;</button>
        {quantity}
        <button onClick={incrementHandler}>&#9654;</button>
      </td>
      <td className="td_price">{addDotsToPrice(totalPriceOfProduct)}</td>
      <td>
        <button onClick={deleteHandler}>
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </td>
    </tr>
  );
};

export default CartRow;
